import { render, staticRenderFns } from "./NumCardWidget.vue?vue&type=template&id=6cd2a3c8&scoped=true&"
import script from "./NumCardWidget.vue?vue&type=script&lang=ts&"
export * from "./NumCardWidget.vue?vue&type=script&lang=ts&"
import style0 from "./NumCardWidget.vue?vue&type=style&index=0&id=6cd2a3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd2a3c8",
  null
  
)

export default component.exports